import { render, staticRenderFns } from "./page-grid copy.vue?vue&type=template&id=534e1e15"
import script from "./page-grid copy.vue?vue&type=script&lang=js"
export * from "./page-grid copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports